/** Single source of truth for notifications TanStack Query keys. */
export const notificationsKeys = {
  /** Every site's list — what a signal from the stream invalidates. */
  all: () => ['notifications'] as const,
  /** The person's notifications in one site — what the bell and the tab show. */
  list: (siteId: string) => ['notifications', siteId] as const,
};
